module.exports = __webpack_public_path__ + "static/bigant-portrait.7371712a.png";


//////////////////
// WEBPACK FOOTER
// ./src/gallery/thumbs/bigant-portrait.png
// module id = 562
// module chunks = 27362984104999